import script from "./JoinUs.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinUs.vue?vue&type=script&setup=true&lang=js"

import "./JoinUs.vue?vue&type=style&index=0&id=a31f2c26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a31f2c26"]])

export default __exports__